import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface PageTitleProps {
  title: string;
  children: React.ReactNode;
}

const PageTitle: React.FC<PageTitleProps> = ({ title, children }) => {
  const location = useLocation();

  useEffect(() => {
    document.title = title;
  }, [location, title]);

  return <>{children}</>;
};

export default PageTitle;
